<template>
    <Head :title="'Top Schools in Northeast Florida'" >
        <link rel="canonical" href="https://www.ginabetbeze.com/school-info" />
        <meta name="description" content="Find information on schools in Northeast Florida." />
    </Head>

    <PageContent
        :id="'School-info-page'"
        :breadcrumbs="['Home','Resources', 'School Information']"
        :header="'School information'"
    >
        <BasicContainer>
            <SecondaryHeader>Information and links for for Duval, Clay, and St. Johns County schools</SecondaryHeader>

            <SecondaryHeader id="stjohnscounty">St. Johns County Schools</SecondaryHeader>
            <Paragraph>
                St. Johns County is renowned for its exceptional school system, consistently ranked among the best in
                Florida. The area offers a variety of educational options, including highly-rated public schools,
                private institutions, and specialized programs that cater to diverse learning needs.
            </Paragraph>
            <Paragraph>
                <a class="flex items-center" href="https://www.stjohns.k12.fl.us/" target="_blank" rel="noreferrer">
                    St. Johns County School District Website
                    <ArrowTopRightOnSquareIcon class="h-4 w-4 ml-0 hidden tablet-sm:blockinline-block font-semibold stroke-2" />
                </a>
            </Paragraph>
            <Paragraph>
                <a
                    class="ml-4 flex items-center"
                    href="https://www.stjohns.k12.fl.us/zoning/"
                    target="_blank"
                    rel="noreferrer"
                >
                    St. Johns County School District Zoning Information
                    <ArrowTopRightOnSquareIcon class="h-4 w-4 ml-0 hidden tablet-sm:blockinline-block font-semibold stroke-2" />
                </a>
            </Paragraph>
            <Paragraph>
                <a
                    class="ml-4 flex items-center"
                    href="https://www.fldoe.org/accountability/accountability-reporting/school-grades/"
                    target="_blank"
                    rel="noreferrer"
                >
                    All Florida School Grades can be found at Florida Department of Education's Website
                    <ArrowTopRightOnSquareIcon class="h-4 w-4 ml-0 hidden tablet-sm:blockinline-block font-semibold stroke-2" />
                </a>
            </Paragraph>

            <SecondaryHeader id="stjohnscounty">Duval County Schools</SecondaryHeader>
            <Paragraph>
                Duval County is known for its commitment to education, offering a variety of schooling options that
                cater to the needs of its diverse community. The area boasts a range of public schools, private
                institutions, and specialized programs, providing students with opportunities to excel academically and
                prepare for future success.
            </Paragraph>
            <Paragraph>
                <a class="flex items-center" href="https://dcps.duvalschools.org/" target="_blank" rel="noreferrer">
                    Duval County School District Website
                    <ArrowTopRightOnSquareIcon class="h-4 w-4 ml-0 hidden tablet-sm:blockinline-block font-semibold stroke-2" />
                </a>
            </Paragraph>
            <Paragraph>
                <a
                    class="ml-4 flex items-center"
                    href="https://www.myschoollocation.com/duvalcountypublicschools/"
                    target="_blank"
                    rel="noreferrer"
                >
                    Duval County School District "Find My School" Map
                    <ArrowTopRightOnSquareIcon class="h-4 w-4 ml-0 hidden tablet-sm:blockinline-block font-semibold stroke-2" />
                </a>
            </Paragraph>
            <Paragraph>
                <a
                    class="ml-4 flex items-center"
                    href="https://www.fldoe.org/accountability/accountability-reporting/school-grades/"
                    target="_blank"
                    rel="noreferrer"
                >
                    All Florida School Grades can be found at Florida Department of Education's Website
                    <ArrowTopRightOnSquareIcon class="h-4 w-4 ml-0 hidden tablet-sm:blockinline-block font-semibold stroke-2" />
                </a>
            </Paragraph>

            <SecondaryHeader id="stjohnscounty">Clay County Schools</SecondaryHeader>
            <Paragraph>
                Clay County is recognized for its strong educational system, offering a variety of schooling options
                that serve its growing community. The county features well-regarded public schools, respected private
                institutions, and specialized programs, all designed to support student achievement and prepare them for
                future endeavors.
            </Paragraph>
            <Paragraph>
                <a class="flex items-center" href="https://www.myoneclay.net/" target="_blank" rel="noreferrer">
                    Clay County School District Website
                    <ArrowTopRightOnSquareIcon class="h-4 w-4 ml-0 hidden tablet-sm:blockinline-block font-semibold stroke-2" />
                </a>
            </Paragraph>
            <Paragraph>
                <a
                    class="ml-4 flex items-center"
                    href="https://bus.myoneclay.net/find-your-school-zone/school-rezoning"
                    target="_blank"
                    rel="noreferrer"
                >
                    Clay County School District School Zone information
                    <ArrowTopRightOnSquareIcon class="h-4 w-4 ml-0 hidden tablet-sm:blockinline-block font-semibold stroke-2" />
                </a>
            </Paragraph>
            <Paragraph>
                <a
                    class="ml-4 flex items-center"
                    href="https://www.fldoe.org/accountability/accountability-reporting/school-grades/"
                    target="_blank"
                    rel="noreferrer"
                >
                    All Florida School Grades can be found at Florida Department of Education's Website
                    <ArrowTopRightOnSquareIcon class="h-4 w-4 ml-0 hidden tablet-sm:blockinline-block font-semibold stroke-2" />
                </a>
            </Paragraph>
        </BasicContainer>
    </PageContent>
</template>
<script setup>
import HomeLayout from "../Layouts/HomeLayout.vue";
import PageContent from "../Components/Layout/PageContent.vue";
import { Head, usePage } from "@inertiajs/vue3";
import { ArrowTopRightOnSquareIcon } from "@heroicons/vue/24/outline";
import Breadcrumbs from "@/Components/PageContent/Breadcrumbs.vue";
import MainHead from "@/Components/PageContent/MainHead.vue";
import Paragraph from "@/Components/PageContent/Paragraph.vue";
import BasicContainer from "@/Components/PageContent/Containers/BasicContainer.vue";
import SecondaryHeader from "@/Components/PageContent/SecondaryHeader.vue";

defineOptions({ layout: HomeLayout });
const page = usePage();
const props = defineProps({
    title: {
        type: String,
        required: true,
    },
});

</script>
